var yousers = require('@yola/yousersjs');

function updateUserProperty(name, value) {
    yousers
        .preferences()
        .put(name, value)
        .catch(console.error);
}

module.exports = updateUserProperty;